import React, { useState, useEffect } from 'react';
import Modal from '../modals/Modal';
import { api } from '../../api';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import { decimalTo } from '../../utils/utils';

const TopUpHistory = (props) => {
  const token = useSelector((state) => state.auth.token);
  const { id: merchentId } = useParams(); 
  // eslint-disable-next-line
  const navigate = useNavigate();
  const [viewMerchant, setViewMerchent] = useState([])
  const [openProof, setOpenProof] = useState(false)
    // eslint-disable-next-line
  const [openModal, setOpenModal] = useState(false)
  const [indexValue, setIndexValue] = useState('');
  const cdn = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_UPLOAD_PATH}`;

  
  const reqPayLoad = {
    "pageNo": 1,
    "pageSize": 5,
    "merchentId": merchentId,
    "transactionType": 2
  }

  useEffect(() => {
    api.merchants.getTopUpHistory(reqPayLoad,token).then(res => {
      if (res.success === true) {
        const { data: { result } } = res;
        setViewMerchent(result || [])
      }
      else if (res.success === false) {
        toast.error(res.message);
      }
    }).catch(err => {
      toast.error("Something went wrong");
    })
      // eslint-disable-next-line
  }, [])

  const viewProof = (index) => {
    setOpenProof(true);
    setIndexValue(index);
  }

  const closeModalPopUp = () => {
    setOpenProof(false);
  }

  return (
    <>
<div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <div className="table-head">
              <h1 className="sec-header">
                Top-Up History
                {/* <AddButton link="/add-merchants" buttonName="ADD MERCHANTS" appRole={addAccess} /> */}
              </h1>
            </div>

            <div className="card card-table">
              <div className="card-header card-header-title">
                Top-Up History
             
              </div>
              {/* table */}

              <div className="card-body gatepass-saveoutput">
                <div className="reports">
                <table className="table">
                    <thead>
                      <tr>
                        <th>Payment Date</th>
                        <th>Amount</th>
                        <th>Mode</th>
                        <th>Transaction No</th>
                        <th>Notes</th>
                        <th>Credit Available</th>
                        <th>Transaction Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>

                      {viewMerchant.length > 0 && viewMerchant.map((row, index) => {
                        return (
                          <tr key={index}>
                            {/* <td><Link to={`view-merchants/${dt.merchantId}`}>{dt.merchentName}</Link></td> */}
                            <td>{row.paymentDate}</td>
                            <td>{row.amount}</td>
                            <td>{row.mode}</td>
                            <td>{row.transactionNo}</td>
                            <td>{row.notes}</td>
                            <td>{decimalTo(row.creditAvalable).toFixed(2)}</td>
                            <td>{row.transactionType}</td>
                            <td><button className="btn" variant="primary" disabled={ row.document !== '' ? false : true} onClick={() => viewProof(index)}> Proof</button></td>
                          </tr>
                        )
                      })
                      }

                      {
                        viewMerchant.length === 0 &&
                        <tr>
                          <td colSpan='8' className="noData">No data found</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>

              {/* table */}
            </div>
          </div>
        </div>
      </div>
    </div>
    
      {
        openProof && <Modal
        modalHeader="Transaction Proof"
        showModal={openProof}
        closeModal={closeModalPopUp}
        // buttonText="SAVE"
      >
        <img src={`${cdn}${viewMerchant[indexValue].document}`} alt="nodwin" height="100%" width="100%" />
      </Modal>
      }
     
    </>
  )
}

export default TopUpHistory;